import { FormikProps } from 'formik';

import {
  buildBracketCellChildMatchId,
  generateMatchId,
} from './bracketCellCreate.util';
import { getBracketCellId } from './bracketCellPendingDeletes.util';
import { IMatch, PlayValues } from '../pages/tourDetails/TournamentPlay/components/PlayTag/PlayTag';

export type BracketCellLayout = {
  round: number;
  isGold: boolean;
  bracket: number;
};

function toBoolean(value: unknown): boolean {
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'number') {
    return value !== 0;
  }
  return value === 'true';
}

export function parseBracketCellLayout(layout: {
  round?: number | string;
  isGold?: boolean | string;
  bracket?: number | string;
}): BracketCellLayout {
  return {
    round: Number(layout.round ?? 1),
    isGold: toBoolean(layout.isGold ?? false),
    bracket: Number(layout.bracket ?? 0),
  };
}

function cellMatches(
  matches: PlayValues['tournamentMatches'],
  cellId: string,
): IMatch[] {
  return Object.values(matches)
    .filter((m) => getBracketCellId(m) === cellId)
    .sort(
      (a, b) => (a.bracketCellMatchIndex ?? 0) - (b.bracketCellMatchIndex ?? 0),
    );
}

export function syncBracketCellLayoutToMatches(
  formikArg: FormikProps<PlayValues>,
  cellId: string,
  layout: BracketCellLayout,
): void {
  const matches = cellMatches(formikArg.values.tournamentMatches, cellId);
  if (matches.length === 0) {
    return;
  }

  const anchor = matches.find((m) => m.bracketCellMatchIndex === 1) ?? matches[0];
  const sortKey = anchor.sortKey ?? 1;
  const legacyBase = generateMatchId(sortKey, layout.isGold, layout.round);
  const isGoldStr = String(layout.isGold);
  const newMatches = {
    ...formikArg.values.tournamentMatches,
  } as Record<string, IMatch>;

  for (const match of matches) {
    const index = match.bracketCellMatchIndex ?? 1;
    const matchId = buildBracketCellChildMatchId(legacyBase, index, {
      isTiebreaker: match.isTiebreaker,
    });
    newMatches[String(match.id)] = {
      ...match,
      type: layout.round,
      bracket: layout.bracket,
      isGold: isGoldStr,
      matchId,
    };
  }

  formikArg.setFieldValue('tournamentMatches', newMatches);
}
